<div class="container">
    <div class="main-box">
        <div class="row justify-content-center align-content-center mhead">

            <div class="col-7 text-center">
                <h1>Empieza a crear tu minibio</h1>
                <button (click)="login()" type="button" class="btn mt-4 btn-light">
                  <img src="../../assets/img/google.svg" alt="google">
                  Entrar con Google
                </button>
            </div>

        </div>
    </div>
</div>